import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  showDropdown = false;
  @Input() dropdownLabel ;
  currentUser: any;

  constructor() {
  }
  ngOnInit() {
  }
  openDropdown() {
    this.showDropdown = !this.showDropdown;
  }
  onSignout()
  {
  }
}



